import { jsx as _jsx } from "react/jsx-runtime";
import MuiPaper from '@mui/material/Paper';
import * as React from 'react';
import { useFlexBoxProps } from '../box';
import { usePaletteColor } from '../theme';
export const Paper = React.forwardRef((props, ref) => {
    const { backgroundColor: _backgroundColor, width, height, ...paperProps } = props;
    const backgroundColor = usePaletteColor(_backgroundColor ?? 'background.paper');
    return (_jsx(MuiPaper, { ref: ref, ...paperProps, sx: {
            backgroundColor,
            width,
            height,
            ...paperProps.sx
        } }));
});
export const FlexPaper = React.forwardRef((props, ref) => {
    const { gap, vAlign, hAlign, stretch, autoShrink, stack, ...paperProps } = props;
    const flexProps = useFlexBoxProps({
        autoShrink,
        gap,
        vAlign,
        hAlign,
        stretch,
        stack
    });
    return (_jsx(Paper, { ref: ref, ...paperProps, sx: {
            ...flexProps,
            ...paperProps.sx
        } }));
});
